/**
 * Extrae un mensaje legible del error de una respuesta API.
 * Maneja tanto strings como arrays de objetos (errores de validación Pydantic).
 */
export const getErrorDetail = (err, fallback = 'Error desconocido') => {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map(d => {
      if (typeof d === 'string') return d;
      if (d.msg) {
        const field = d.loc ? d.loc[d.loc.length - 1] : '';
        return field ? `${field}: ${d.msg}` : d.msg;
      }
      return JSON.stringify(d);
    }).join('; ');
  }
  if (typeof detail === 'object') return JSON.stringify(detail);
  return String(detail);
};
